import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import clsx from "clsx";
import React from 'react';

interface SystemTooltipProps extends Omit<TooltipProps, 'title'> {
    message?: string;
}

export const SystemTooltip: React.FC<SystemTooltipProps> = ({ children, message }) => {
    return (
        <Tooltip
            title={message ? <span dangerouslySetInnerHTML={{ __html: message }}></span> : undefined}
            placement="top"
            classes={{
                tooltip: clsx(
                    tooltipClasses.tooltip,
                    "bg-cs-800 text-white text-sm px-3 py-2 rounded shadow-lg"
                ),
            }}
            arrow
        >
            <div>
                {children}
            </div>
        </Tooltip>
    );
}
